class CartQf {
  constructor() {
    this.cart = window.QF.cart;
    this.cartOpen = false;
    this.redirect = false
    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      change: {
        url: 'cart/change.js',
        method: 'post'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    };

    this.selectors = {
      cartDrawerContainer: '#cart-drawer-container'
    };
  }

  dispatchEvent(event_name, includeCart, newestItem = null) {
    let contents = null;
    if (newestItem) {
      let newestItemKeyOrId;
      if (typeof newestItem === 'object' && !Array.isArray(newestItem)) {
        newestItemKeyOrId = Object.keys(newestItem)[0];
      } else if (Array.isArray(newestItem) && newestItem.length > 0) {
        newestItemKeyOrId = newestItem[0].id;
      } else {
        newestItemKeyOrId = null;
      }

      newestItem = newestItemKeyOrId;
    }


    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
          newestItem: newestItem
        },
      };
    }
    window.dispatchEvent(new CustomEvent(event_name, contents));
  }

  async add(data) {
    console.log(data);
    try {
      await this.request('add', data);
      const response = await this.request('get');
      this.cart = response;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true, data.items);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async get() {
    try {
      const response = await this.request('get');
      this.cart = response.data;
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async update(data, updateType = null) {
    try {
      const responseData = await this.request('update', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      if (updateType != null) {
        if (updateType == 'plus') {
          this.dispatchEvent("item_added", true, data.updates);
        } else {
          this.dispatchEvent("item_removed", true);
        }
      }
      if (this.redirect == true && window.location.pathname.includes('/cart') == false)
        window.location.href = '/cart'
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async remove(variant_id) {
    try {
      const updates = {
        updates: {
          [variant_id]: 0,
        }
      };
      const { data: responseData } = await this.request('update', updates);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_removed", true);
      if (this.redirect == true && window.location.pathname.includes('/cart') == false)
        window.location.href = '/cart'
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async clear() {
    try {
      const { data: responseData } = await this.request('clear');
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("cart_cleared", true);
      if (this.redirect == true && window.location.pathname.includes('/cart') == false)
        window.location.href = '/cart'
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async change(data) {
    try {
      await this.request('change', data);
      const response = await this.request('get');
      this.cart = response;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true);
      console.log(data);
      if (this.redirect == true && window.location.pathname.includes('/cart') == false)
        window.location.href = '/cart'
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async request(key, data) {
    try {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data)
      });

      if (response.ok) {
        return response.json();
      } else {
        throw await response.json();
      }
    } catch (error) {
      throw error;
    }
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item);
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      //const cart_tabs = document.querySelectorAll('.cart-tabs .cart-tab');
      const cart_content = document.querySelector('.basket-cart');

      cart_content.style.display = 'flex';
      //cart_tabs[0].classList.add('active');

      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        });
        sideCartContainer.querySelector('.side-cart-recommended').classList.add('open');
        if (!this.cartOpen) {
          this.dispatchEvent("side_cart_opened", true);
          this.cartOpen = true;
        }
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.querySelector('.side-cart-recommended').classList.remove('open');
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", true);
      this.cartOpen = false;
    }
  }

  async reRenderSideCart(successCallback = null) {
    try {
      const response = await fetch("/cart?sections=v2-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const html = data["v2-side-cart"];

      const side_cart_inner = document.querySelector("#cart-drawer-container .inner");
      if (side_cart_inner && html) {
        side_cart_inner.innerHTML = html;

        let item_count = parseInt(side_cart_inner.querySelector('.cart').getAttribute('data-items-count'));
        let cart_count_el = document.querySelector('.cart-counter');

        if (item_count == 0) {
          cart_count_el.style.opacity = "0";
        } else if (item_count == 1) {
          cart_count_el.style.opacity = "1";
          cart_count_el.innerHTML = `${item_count}`;
        } else {
          cart_count_el.style.opacity = "1";
          cart_count_el.innerHTML = `${item_count}`;
        }

        // Check for subscription products and hide the additional checkout buttons

        let subscription_items = side_cart_inner.querySelectorAll('.items .item .selling-plan');
        const button_container = document.querySelector('.buttons');
        const checkout_buttons = document.querySelector('.additional-checkout-buttons');

        checkForElement = () => {

          if (checkout_buttons) {
            clearInterval(interval);
            if (subscription_items.length < 1 ) {
              button_container.classList.add('has-additional-buttons');
              checkout_buttons.style.display = 'block';
              clearInterval(interval);
            } else {
              button_container.classList.remove('has-additional-buttons');
              checkout_buttons.style.display = 'none';
            }
          }

          if (checkout_buttons) {
            clearInterval(interval);
            checkout_buttons.classList.add('additional-checkout-buttons--toggled');
          }

        }

        let interval = setInterval(checkForElement, 200);

        // Hide google pay button if apple pay is available - NO LONGER WORKS
        // if (window.ApplePaySession) {
        //   var googlePay = document.querySelector('[data-testid="GooglePay-button"]');
        //   if(googlePay) {
        //     var parent = googlePay.parentNode;
        //     parent.style.display = 'none';
        //   }
        // }

        // Change subtotal to match the cart total
        const subtotal_el = document.querySelector('#cart-drawer .sub-total .total-price');
        const total_savings_el = document.querySelector('#cart-drawer .sub-total .total-savings');
        const cart_total = side_cart_inner.querySelector('.cart').dataset.subTotal / 100;
        const cart_savings = side_cart_inner.querySelector('.cart').dataset.totalSavings / 100;

        subtotal_el.innerHTML = `£${cart_total.toFixed(2)}`;
        if (cart_savings > 0 && cart_savings !== cart_total) {
          total_savings_el.innerHTML = `£${cart_savings.toFixed(2)}`;
        } else {
          total_savings_el.innerHTML = '';
        }

        const free_delivery_el = document.querySelector('.free-delivery-status');
        const free_delivery_trigger = free_delivery_el.dataset.freeDelivery;

        if (!free_delivery_trigger) {
          free_delivery_el.style.display = 'none';
        } else if (cart_total < free_delivery_trigger) {
          const spend_more = (free_delivery_trigger - cart_total).toFixed(2);
          free_delivery_el.innerHTML = `£${spend_more} away from free delivery`;
        } else {
          free_delivery_el.innerHTML = `Yay! You've qualified for free delivery!`;
        }

        new window.swiper('.side-cart-recommendations-slider', {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          breakpoints: {
            992: {
              slidesPerView: 2.5,
              spaceBetween: 25,
            }
          },
          lazy: {
            enabled: true,
            checkInView: false,
            loadOnTransitionStart: true,
            loadPrevNext: true,
            loadPrevNextAmount: 1
          },
          on: {
            touchStart: () => {
              isDragging = false;
              console.log("isDragging: " + isDragging)
            },
            touchMove: () => {
              isDragging = true;
              console.log("isDragging: " + isDragging)
            },
            touchEnd: () => {
              if (isDragging) {
                console.log("blockOutsideClicks");
                blockOutsideClicks();
              }
            }
          }
        });

        if (window.innerWidth > 1099.5) {
          new window.swiper(".cart-recommendations-slider", {
            slidesPerView: 2,
            spaceBetween: 20,
            navigation: {
              nextEl: ".swiper-button-next.cart-rec",
              prevEl: ".swiper-button-prev.cart-rec",
            },
            lazy: {
              enabled: true,
              checkInView: false,
              loadOnTransitionStart: true,
              loadPrevNext: true,
              loadPrevNextAmount: 1
            },
            breakpoints: {
              992: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            },
            navigation: {
              nextEl: '.cart-recommendations-swiper-button-next.swiper-button-next',
              prevEl: '.cart-recommendations-swiper-button-prev.swiper-button-prev',
            },
            on: {
              touchStart: () => {
                isDragging = false;
                console.log("isDragging: " + isDragging)
              },
              touchMove: () => {
                isDragging = true;
                console.log("isDragging: " + isDragging)
              },
              touchEnd: () => {
                if (isDragging) {
                  console.log("blockOutsideClicks");
                  blockOutsideClicks();
                }
              }
            }
          });
        }
        this.cartRenderedEvent(response, html);

        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }

    function blockOutsideClicks() {
      const clickHandler = (e) => {
        if (!e.target.closest('.swiper')) {
          e.stopPropagation();
          e.preventDefault();
        }
        document.removeEventListener('click', clickHandler, true);
      };
      document.addEventListener('click', clickHandler, true);
    }

  }

  reRenderCart() {
    let cart_inner = document.querySelector("#cart-container");
    const section_id = cart_inner.getAttribute('data-section-id')
    let target = document.querySelector("#cart-container").parentNode;
    fetch("/cart?section_id=" + section_id)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text(); // Parse the response as JSON
    })
    .then((html) => {
      // Extract the "v2-cart" field from the JSON data
      if (target && html) {
        target.innerHTML = html;
        this.cartRenderedEvent(html);
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  }

  cartRenderedEvent(response, html) {
    const event = new CustomEvent("cart_rendered", {
      detail: {
        response,
        html,
      },
    });
    window.dispatchEvent(event);
  }

  addcheckoutoptions() {
    var buttonsoptions = document.querySelector('.cart-details .buttons');
    var additionalcheckoutbuttons = document.querySelector('.additional-checkout-buttons');
    if(additionalcheckoutbuttons && buttonsoptions) {
        // additionalcheckoutbuttons.style.display = 'none';

        var shoppay = document.querySelector('[data-testid="ShopifyPay-button"]');
        if(shoppay) {
            var div = document.createElement("div");
            div.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0402/7685/2896/files/shopify_pay.svg?v=1695728407" />';
            div.setAttribute('newacs','ShopifyPay-button');
            div.classList.add('acsshoppay');
            div.classList.add('acsbutton');
            div.addEventListener("click", function (e) {
                shoppay.click();
            });
            buttonsoptions.append(div);
        }

        var googlepay = document.querySelector('[data-testid="GooglePay-button"]');
        if(googlepay) {
            var div = document.createElement("div");
            div.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0402/7685/2896/files/google-pay.svg?v=1695728407" />';
            div.setAttribute('newacs','GooglePay-button');
            div.classList.add('acsgooglepay');
            div.classList.add('acsbutton');
            div.addEventListener("click", function (e) {
                googlepay.click();
            });
            buttonsoptions.append(div);
        }

        var paypal = document.querySelector('[data-testid="Paypal-button"]');
        if(paypal) {
            var div = document.createElement("div");
            div.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0402/7685/2896/files/paypal.svg?v=1695728407" />';
            div.setAttribute('newacs','PayPal-button');
            div.classList.add('acspaypal');
            div.classList.add('acsbutton');
            div.addEventListener("click", function (e) {
                paypal.click();
            });
            buttonsoptions.append(div);
        }

        var applePay = document.querySelector('[data-testid="ApplePay-button"]');
        if(applePay) {
            var div = document.createElement("div");
            div.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0402/7685/2896/files/apple-pay-payment-mark.svg?v=1695728407" />';
            div.setAttribute('newacs','ApplePay-button');
            div.classList.add('acsapple');
            div.classList.add('acsbutton');
            div.addEventListener("click", function (e) {
                applePay.click();
            });
            buttonsoptions.append(div);
        }

    }
  }

}

const additionalCheckoutButtons = document.querySelector(".additional-checkout-buttons");

if(additionalCheckoutButtons){
  document.querySelector(".additional-checkout-buttons").addEventListener("click",function(){
    this.classList.toggle("additional-checkout-buttons--toggled");
  });
}

window.CartQf = CartQf;